import { Injectable } from '@angular/core';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { environment } from './../../environments/environment';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable({
	providedIn: 'root',
})
export class DatadogService {
	initializeDatadog(): void {
		const datadogConfig: RumInitConfiguration = {
			applicationId: environment.dataDogApplicationId,
			clientToken: environment.dataDogClientToken,
			site: 'us3.datadoghq.com',
			service: environment.datadogService,
			env: environment.datadogEnv,
			allowedTracingUrls: [environment.datadogIP, environment.baseUrl],
			version: environment.version,
			sessionSampleRate: 100,
			sessionReplaySampleRate: 20,
			trackUserInteractions: true,
			trackResources: true,
			trackLongTasks: true,
			defaultPrivacyLevel: 'mask-user-input', // 'allow',
		};
		datadogRum.init(datadogConfig);

		datadogLogs.init({
			clientToken: environment.dataDogClientToken,
			site: 'us3.datadoghq.com',
			forwardErrorsToLogs: true,
			sessionSampleRate: 100,
			useSecureSessionCookie: true,
		});

		datadogRum.setGlobalContext({
			product: 'digital-harbour',
		});
	}
}
